import { StyleDeclarationValue, css } from 'aphrodite';
import { FC, useEffect, useState } from 'react';
import { useDebounceCallback } from '../../../../hooks/useDebounceValue';
import { useAdvancedFiltersContext } from '../../../components-v2/AdvancedFilters/AdvancedFiltersContext';
import { Input } from '../../../components-v2/Input';
import { Label } from '../../../components-v2/Label';
import { styleSheet } from './styles';

interface JobTitleFilterPanelProps {
	className?: string;
	styles?: (StyleDeclarationValue | false)[];
	disabled?: boolean;
	onChangeDebounced?: () => void;
}

const DEBOUNCE_MS = 300;

export const JobTitleFilterPanel: FC<JobTitleFilterPanelProps> = ({
	className,
	styles = [],
	disabled = false,
	onChangeDebounced,
}) => {
	const { jobTitleFilters } = useAdvancedFiltersContext();
	const { jobTitle, setJobTitle } = jobTitleFilters;

	const [localJobTitle, setLocalJobTitle] = useState(jobTitle);

	useEffect(() => {
		setLocalJobTitle(jobTitle);
	}, [jobTitle]);

	const debouncedSetJobTitle = useDebounceCallback((value: string) => {
		setJobTitle(value);
		onChangeDebounced?.();
	}, DEBOUNCE_MS);

	const handleJobTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (disabled) return;
		const value = e.target.value;
		setLocalJobTitle(value);
		debouncedSetJobTitle(value);
	};

	return (
		<div className={`${css(styleSheet.container, ...(styles?.filter(Boolean) || []))} ${className || ''}`}>
			<div className={css(styleSheet.fieldContainer)}>
				<Label htmlFor='job-title-filter' styles={[styleSheet.fieldLabel]}>
					Job Title
				</Label>
				<Input
					id='job-title-filter'
					type='text'
					value={localJobTitle}
					onChange={handleJobTitleChange}
					placeholder='e.g., Financial Advisor'
					autoComplete='off'
					disabled={disabled}
				/>
			</div>
		</div>
	);
};
